var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.804071 8.20092C0.353875 7.72707 0.354649 6.98334 0.805833 6.51044L6.35986 0.688999C6.71779 0.313828 7.31662 0.313828 7.67455 0.688999C8.01008 1.04068 8.00938 1.59414 7.67297 1.94497L3.29689 6.50858C2.84299 6.98192 2.84205 7.72866 3.29474 8.20315L7.64676 12.7647C7.98171 13.1158 7.98171 13.6681 7.64676 14.0192C7.28827 14.3949 6.68832 14.3943 6.33061 14.0178L0.804071 8.20092Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.141b6ff34e7c017f08f0620aa6de8b8a.svg";
export { ForwardRef as ReactComponent };